import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  DailyFormConfig,
  KpiAreaOption,
  KpiFormConfig,
  ReportingCostCenter,
  SaveDailyFormPayload,
  SaveFormPayload,
} from '../models/reporting.model';
import { PeriodMode } from '../models/period.model';

@Injectable({ providedIn: 'root' })
export class ReportingApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/reporting`;

  costCenters(): Observable<ReportingCostCenter[]> {
    return this.http.get<ReportingCostCenter[]>(`${this.baseUrl}/cost-centers`);
  }

  pages(costCenterId: number): Observable<KpiAreaOption[]> {
    const params = new HttpParams().set('costCenterId', costCenterId);
    return this.http.get<KpiAreaOption[]>(`${this.baseUrl}/pages`, { params });
  }

  form(
    costCenterId: number,
    pageId: number,
    monthId: number,
    mode: PeriodMode
  ): Observable<KpiFormConfig> {
    const params = new HttpParams()
      .set('costCenterId', costCenterId)
      .set('pageId', pageId)
      .set('monthId', monthId)
      .set('mode', mode);
    return this.http.get<KpiFormConfig>(`${this.baseUrl}/form`, { params });
  }

  save(payload: SaveFormPayload): Observable<{ savedCount: number }> {
    return this.http.post<{ savedCount: number }>(
      `${this.baseUrl}/save`,
      payload
    );
  }

  daily(costCenterId: number, monthId: number): Observable<DailyFormConfig> {
    const params = new HttpParams()
      .set('costCenterId', costCenterId)
      .set('monthId', monthId);
    return this.http.get<DailyFormConfig>(`${this.baseUrl}/daily`, { params });
  }

  saveDaily(payload: SaveDailyFormPayload): Observable<{ savedCount: number }> {
    return this.http.post<{ savedCount: number }>(
      `${this.baseUrl}/daily/save`,
      payload
    );
  }

  saveWorkingDays(
    costCenterId: number,
    monthId: number,
    workingDays: number
  ): Observable<{ days: number }> {
    return this.http.put<{ days: number }>(
      `${this.baseUrl}/daily/working-days`,
      { costCenterId, monthId, workingDays }
    );
  }
}
